import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Input, Row, Space, Typography } from 'antd';

const { Text } = Typography;

const AddressInput = ({ label, name, value, error, onChange, disabled }) => {
  return (
    <div>
      <Text strong>{label}</Text>
      <div style={{ marginTop: 4 }}>
        <Input
          value={value || ''}
          disabled={disabled}
          onChange={(e) =>
            onChange({
              target: {
                name,
                value: e.target.value,
              },
            })
          }
        />
      </div>
      {error && (
        <Text type="danger" style={{ fontSize: 12 }}>
          {error}
        </Text>
      )}
    </div>
  );
};

AddressInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const AddressUserForm = ({
  formData,
  errors = {},
  handleInputChange,
  isEditMode,
}) => {
  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Card size="small" style={{ borderRadius: 12 }}>
        <div style={{ marginBottom: 12 }}>
          <Text strong style={{ fontSize: 15 }}>
            Permanent Address
          </Text>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              This section stays read-only during edit mode, matching current behavior.
            </Text>
          </div>
        </div>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <AddressInput
              label="Street"
              name="permanentStreet"
              value={formData.permanentStreet || ''}
              error={errors.permanentStreet}
              onChange={handleInputChange}
              disabled={isEditMode}
            />
          </Col>
          <Col xs={24} md={12}>
            <AddressInput
              label="City"
              name="permanentCity"
              value={formData.permanentCity || ''}
              error={errors.permanentCity}
              onChange={handleInputChange}
              disabled={isEditMode}
            />
          </Col>
          <Col xs={24} md={12}>
            <AddressInput
              label="State"
              name="permanentState"
              value={formData.permanentState || ''}
              error={errors.permanentState}
              onChange={handleInputChange}
              disabled={isEditMode}
            />
          </Col>
          <Col xs={24} md={12}>
            <AddressInput
              label="Zip Code"
              name="permanentZipCode"
              value={formData.permanentZipCode || ''}
              error={errors.permanentZipCode}
              onChange={handleInputChange}
              disabled={isEditMode}
            />
          </Col>
          <Col xs={24} md={12}>
            <AddressInput
              label="Country"
              name="permanentCountry"
              value={formData.permanentCountry || ''}
              error={errors.permanentCountry}
              onChange={handleInputChange}
              disabled={isEditMode}
            />
          </Col>
        </Row>
      </Card>
    </Space>
  );
};

AddressUserForm.propTypes = {
  formData: PropTypes.object.isRequired,
  errors: PropTypes.object,
  handleInputChange: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  patchProfileProperties: PropTypes.func,
  refetch: PropTypes.func,
  isEditMode: PropTypes.bool,
};

export default AddressUserForm;
